export const HANDS = [
  {
    name: 'Hueycoatl Hide Vambraces',
    slot: 'hands',
    regions: ['Varlamore'],
    requirements: [{ skill: 'Ranged', level: 70 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: -10, ranged: 11 },
      defence: { stab: 6, slash: 5, crush: 7, magic: 8, ranged: 0 },
      other:   { meleeStrength: 0, rangedStrength: 0, magicDamage: 0, prayer: 1 },
    },
  },
  {
    name: 'Confliction Gauntlets',
    slot: 'hands',
    regions: ['Varlamore'],
    requirements: [{ skill: 'Hitpoints', level: 90 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: 20, ranged: -4 },
      defence: { stab: 15, slash: 18, crush: 7, magic: 5, ranged: 5 },
      other:   { meleeStrength: 0, rangedStrength: 0, magicDamage: 7, prayer: 2 },
    },
    effect: {
      type: 'multiply_totals',
      stats: [],
      description: 'Confliction Gauntlets: Upon a missed magic attack, next magic attack against the same enemy rolls accuracy twice',
    },
  },
  {
    name: 'Ferocious Gloves',
    slot: 'hands',
    regions: ['Kourend'],
    requirements: [{ skill: 'Defence', level: 80 }],
    bonuses: {
      attack:  { stab: 16, slash: 16, crush: 16, magic: -16, ranged: -16 },
      defence: { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      other:   { meleeStrength: 14, rangedStrength: 0, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: 'Zaryte Vambraces',
    slot: 'hands',
    regions: ['Asgarnia'],
    requirements: [{ skill: 'Ranged', level: 80 }],
    bonuses: {
      attack:  { stab: -8, slash: -8, crush: -8, magic: 0, ranged: 18 },
      defence: { stab: 8, slash: 8, crush: 8, magic: 5, ranged: 8 },
      other:   { meleeStrength: 0, rangedStrength: 2, magicDamage: 0, prayer: 1 },
    },
  },
  {
    name: 'Tormented Bracelet',
    slot: 'hands',
    regions: ['Kandarin'],
    requirements: [{ skill: 'Magic', level: 75 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: 10, ranged: 0 },
      defence: { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      other:   { meleeStrength: 0, rangedStrength: 0, magicDamage: 5, prayer: 2 },
    },
  },
  {
    name: 'Barrows Gloves',
    slot: 'hands',
    regions: [],
    requirements: [{ skill: 'Defence', level: 40 }],
    bonuses: {
      attack:  { stab: 12, slash: 12, crush: 12, magic: 6, ranged: 12 },
      defence: { stab: 12, slash: 12, crush: 12, magic: 6, ranged: 12 },
      other:   { meleeStrength: 12, rangedStrength: 0, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: 'Granite Gloves',
    slot: 'hands',
    regions: ['Morytania'],
    requirements: [{ skill: 'Defence', level: 50 }],
    bonuses: {
      attack:  { stab: 5, slash: 5, crush: 9, magic: -3, ranged: -1 },
      defence: { stab: 8, slash: 8, crush: 8, magic: -3, ranged: 5 },
      other:   { meleeStrength: 7, rangedStrength: 0, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: 'Dragon Gloves',
    slot: 'hands',
    regions: [],
    requirements: [{ skill: 'Defence', level: 60 }],
    bonuses: {
      attack:  { stab: 9, slash: 9, crush: 9, magic: 5, ranged: 9 },
      defence: { stab: 9, slash: 9, crush: 9, magic: 5, ranged: 9 },
      other:   { meleeStrength: 9, rangedStrength: 0, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: "Black D'hide Vambraces",
    slot: 'hands',
    regions: [],
    requirements: [{ skill: 'Ranged', level: 40 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: -10, ranged: 11 },
      defence: { stab: 4, slash: 5, crush: 5, magic: 8, ranged: 0 },
      other:   { meleeStrength: 0, rangedStrength: 0, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: 'Void Knight Gloves',
    slot: 'hands',
    regions: [],
    requirements: [{ skill: 'Attack', level: 40 }, { skill: 'Defence', level: 40 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      defence: { stab: 6, slash: 6, crush: 6, magic: 4, ranged: 6 },
      other:   { meleeStrength: 0, rangedStrength: 0, magicDamage: 0, prayer: 0 },
    },
    sets: ['elite_void_mage', 'elite_void_range', 'elite_void_melee'],
  },
  {
    name: 'Infinity Gloves',
    slot: 'hands',
    regions: [],
    requirements: [{ skill: 'Magic', level: 25 }, { skill: 'Defence', level: 25 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: 5, ranged: 0 },
      defence: { stab: 0, slash: 0, crush: 0, magic: 5, ranged: 0 },
      other:   { meleeStrength: 0, rangedStrength: 0, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: 'Ranger Gloves',
    slot: 'hands',
    regions: [],
    requirements: [{ skill: 'Ranged', level: 40 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: -10, ranged: 11 },
      defence: { stab: 1, slash: 2, crush: 1, magic: 2, ranged: 0 },
      other:   { meleeStrength: 0, rangedStrength: 0, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: 'Combat Bracelet',
    slot: 'hands',
    regions: [],
    requirements: [],
    bonuses: {
      attack:  { stab: 7, slash: 7, crush: 7, magic: 3, ranged: 7 },
      defence: { stab: 5, slash: 5, crush: 5, magic: 3, ranged: 5 },
      other:   { meleeStrength: 6, rangedStrength: 0, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: 'Adamant Gloves',
    slot: 'hands',
    regions: [],
    requirements: [{ skill: 'Defence', level: 40 }],
    bonuses: {
      attack:  { stab: 7, slash: 7, crush: 7, magic: 4, ranged: 7 },
      defence: { stab: 7, slash: 7, crush: 7, magic: 4, ranged: 7 },
      other:   { meleeStrength: 7, rangedStrength: 0, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: 'Mithril Gloves',
    slot: 'hands',
    regions: [],
    requirements: [{ skill: 'Defence', level: 40 }],
    bonuses: {
      attack:  { stab: 6, slash: 6, crush: 6, magic: 3, ranged: 6 },
      defence: { stab: 6, slash: 6, crush: 6, magic: 3, ranged: 6 },
      other:   { meleeStrength: 6, rangedStrength: 0, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: 'Rune Gloves',
    slot: 'hands',
    regions: [],
    requirements: [{ skill: 'Defence', level: 40 }],
    bonuses: {
      attack:  { stab: 8, slash: 8, crush: 8, magic: 4, ranged: 8 },
      defence: { stab: 8, slash: 8, crush: 8, magic: 4, ranged: 8 },
      other:   { meleeStrength: 8, rangedStrength: 0, magicDamage: 0, prayer: 0 },
    },
  },
];
